import { faEnvelope } from "@fortawesome/duotone-light-svg-icons"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { faPaperclip } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography, JoonUIColor, JoonColorExpanded } from "@joonapp/web-shared"
import dayjs from "dayjs"

import RoutineIcon from "./RoutineIcon"
import useScheduledMessageModalStore from "./useScheduledMessageModalStore"
import { useUserQuery } from "../../../networking/user/queries"
import { ScheduledMessageWithRoutine } from "../../../types/scheduledMessages"
import { getFormattedTimeInTimezone } from "../../../util/time"
import useCurrentClient from "../hooks/useCurrentClient"

const ScheduledMessageItem = ({
  scheduledMessage,
  isFirstInRoutine,
}: {
  scheduledMessage: ScheduledMessageWithRoutine
  isFirstInRoutine?: boolean
}) => {
  const { onOpen: openScheduledMessageModal } = useScheduledMessageModalStore()

  const { currentClientProfile } = useCurrentClient()

  const { data: user } = useUserQuery()
  const messageIsInPast = dayjs(scheduledMessage.datetime).isBefore(dayjs())

  if (!user || !currentClientProfile) return null

  const clientTime = getFormattedTimeInTimezone(
    scheduledMessage.datetime,
    currentClientProfile?.user.timezone
  )
  const coachTime = getFormattedTimeInTimezone(
    scheduledMessage.datetime,
    user?.timezone
  )

  return (
    <button
      onClick={() =>
        openScheduledMessageModal({
          scheduledMessage,
          timezone: currentClientProfile?.user.timezone!,
        })
      }
    >
      <div
        key={scheduledMessage.id}
        className="flex flex-row gap-2 py-2 hover:bg-neutral-50 cursor-pointer items-start"
      >
        <div className="min-w-5">
          {isFirstInRoutine && (
            <RoutineIcon routine={scheduledMessage.routine} />
          )}
        </div>
        <Typography
          variant="bodyXSmall"
          color={JoonUIColor.text.secondary}
          textAlign="left"
          className="min-w-[52px] max-w-[52px] mt-[2px]"
        >
          {coachTime}
        </Typography>
        <Typography
          variant="bodyXSmall"
          color={JoonUIColor.text.secondary}
          textAlign="left"
          className="min-w-[52px] max-w-[52px] mt-[2px]"
        >
          {clientTime}
        </Typography>
        <div className="flex flex-row gap-2 items-center w-full justify-between pr-2">
          <div className="flex flex-row gap-2 items-start ">
            <FontAwesomeIcon
              icon={faEnvelope}
              fontSize={16}
              style={{
                //@ts-ignore
                "--fa-primary-color": JoonUIColor.icon.accent,
                "--fa-secondary-color": JoonColorExpanded.indigo300,
              }}
              className="mt-[2px]"
            />
            {scheduledMessage.resource && (
              <FontAwesomeIcon
                icon={faPaperclip}
                fontSize={16}
                className="mt-[2px]"
                color={JoonUIColor.icon.accent}
              />
            )}
            <Typography
              variant="bodySmall"
              color={JoonUIColor.text.secondary}
              textAlign="left"
              className={`${
                messageIsInPast ? "line-through" : "none"
              } flex items-center`}
            >
              {scheduledMessage.message}
            </Typography>
          </div>
          {messageIsInPast && (
            <FontAwesomeIcon
              icon={faCheck}
              color={JoonUIColor.semantic.success}
              fontSize={16}
            />
          )}
        </div>
      </div>
    </button>
  )
}

export default ScheduledMessageItem
